import TicketSaleService from './../services/ticket-sale.service'
import { busSeatSelectionConstants } from '../constants/bus-seat-selection.constants'
import { toastActions } from '@actions'
import { Creators as TicketSaleCreators } from '../ducks/ticket-sale/ticket-sale'

// `row`/`column` restart at each floor on double-decker buses, so each seat
// carries its own floorNumber/floorLabel (from layout.floors) and is left
// unstacked — the UI shows one floor at a time via a floor switcher.
function mapSeatCells(layout) {
	const floorLabelByNumber = {}

	;(layout.floors || []).forEach((floor) => {
		floorLabelByNumber[floor.floorNumber] = floor.label
	})

	return layout.cells
		.filter(({ seatNumber, isAvailable }) => seatNumber !== '' && isAvailable)
		.map((cell) => ({
			...cell,
			x: cell.row,
			y: cell.column,
			number: cell.seatNumber,
			available: cell.isAvailable,
			floorLabel: floorLabelByNumber[cell.floorNumber],
		}))
}

const loadBusSeatsGoing = (params) => async (dispatch) => {
	const { data, success, message } = await TicketSaleService.getBusData(
		params,
		busSeatSelectionConstants.LOAD_BUS_SEATS_GOING
	)

	if (!success) {
		throw new Error(message)
	} else {
		const busSeats = mapSeatCells(data.layout)

		dispatch({
			payload: busSeats,
			type: busSeatSelectionConstants.LOAD_BUS_SEATS_GOING,
		})

		dispatch(
			TicketSaleCreators.setExtraDataGoing({
				tax: (data.priceBreakdown && data.priceBreakdown.boardingTax) || 0,
				fee: (data.priceBreakdown && data.priceBreakdown.serviceCharge) || 0,
				toll: (data.priceBreakdown && data.priceBreakdown.toll) || 0,
				insurance: data.priceInsuranceAmount || 0,
			})
		)

		dispatch(
			TicketSaleCreators.setTripEmbarcationGoing({
				boardingTerminal: data.terminals.boarding,
				disembarkingTerminal: data.terminals.disembarking,
			})
		)
	}
}

const loadBusSeatsGoingConexao = (params) => async (dispatch) => {
	// trips/seat-map returns the same { layout, terminals, priceBreakdown }
	// shape regardless of kind - a leg of a connection isn't any different
	// from a direct trip's single leg.
	const { data, success, message } = await TicketSaleService.getBusData(
		{
			...params,
			busCompany: params.enterprise,
		},
		busSeatSelectionConstants.LOAD_BUS_SEATS_GOING
	)

	if (!success) {
		throw new Error(message)
	} else {
		const busSeats = mapSeatCells(data.layout)

		dispatch({
			payload: busSeats,
			type: busSeatSelectionConstants.LOAD_BUS_SEATS_GOING,
		})

		dispatch(
			TicketSaleCreators.setExtraDataGoing({
				tax: (data.priceBreakdown && data.priceBreakdown.boardingTax) || 0,
				fee: (data.priceBreakdown && data.priceBreakdown.serviceCharge) || 0,
				toll: (data.priceBreakdown && data.priceBreakdown.toll) || 0,
				insurance: data.priceInsuranceAmount || 0,
			})
		)

		dispatch(
			TicketSaleCreators.setTripEmbarcationGoing({
				boardingTerminal: data.terminals.boarding,
				disembarkingTerminal: data.terminals.disembarking,
			})
		)
	}
}

const loadBusSeatsReturnConexao = (params) => async (dispatch) => {
	const { data, success, message } = await TicketSaleService.getBusData(
		{
			...params,
			busCompany: params.enterprise,
		},
		busSeatSelectionConstants.LOAD_BUS_SEATS_RETURN
	)

	if (!success || !data) {
		dispatch(
			toastActions.danger({
				message:
					message ||
					'Não foi possível obter as poltronas, tente novamente mais tarde.',
			})
		)
		return
	}

	const busSeats = mapSeatCells(data.layout)

	dispatch({
		payload: busSeats,
		type: busSeatSelectionConstants.LOAD_BUS_SEATS_RETURN,
	})

	dispatch(
		TicketSaleCreators.setExtraDataReturn({
			tax: (data.priceBreakdown && data.priceBreakdown.boardingTax) || 0,
			fee: (data.priceBreakdown && data.priceBreakdown.serviceCharge) || 0,
			toll: (data.priceBreakdown && data.priceBreakdown.toll) || 0,
			insurance: data.priceInsuranceAmount || 0,
		})
	)

	dispatch(
		TicketSaleCreators.setTripEmbarcationReturn({
			boardingTerminal: data.terminals.boarding,
			disembarkingTerminal: data.terminals.disembarking,
		})
	)
}

const loadBusSeatsReturn = (params) => (dispatch) => {
	return TicketSaleService.getBusData(
		params,
		busSeatSelectionConstants.LOAD_BUS_SEATS_RETURN
	).then(({ data, success, message }) => {
		if (!success || !data) {
			dispatch(
				toastActions.danger({
					message:
						message ||
						'Não foi possível obter as poltronas, tente novamente mais tarde.',
				})
			)
			return
		}

		const busSeats = mapSeatCells(data.layout)

		dispatch({
			payload: busSeats,
			type: busSeatSelectionConstants.LOAD_BUS_SEATS_RETURN,
		})

		dispatch(
			TicketSaleCreators.setExtraDataReturn({
				tax: (data.priceBreakdown && data.priceBreakdown.boardingTax) || 0,
				fee: (data.priceBreakdown && data.priceBreakdown.serviceCharge) || 0,
				toll: (data.priceBreakdown && data.priceBreakdown.toll) || 0,
				insurance: data.priceInsuranceAmount || 0,
			})
		)

		dispatch(
			TicketSaleCreators.setTripEmbarcationReturn({
				boardingTerminal: data.terminals.boarding,
				disembarkingTerminal: data.terminals.disembarking,
			})
		)
	})
}

const selectBusSeatGoing = (payload) => (dispatch) => {
	dispatch({
		payload,
		type: busSeatSelectionConstants.SELECT_BUS_SEAT_GOING,
	})
	dispatch(TicketSaleCreators.setPriceGoing(payload.price))
}

const deselectBusSeatGoing = (payload) => (dispatch) => {
	dispatch({
		payload,
		type: busSeatSelectionConstants.DESELECT_BUS_SEAT_GOING,
	})
}

const selectBusSeatReturn = (payload) => (dispatch) => {
	dispatch({
		payload,
		type: busSeatSelectionConstants.SELECT_BUS_SEAT_RETURN,
	})
	dispatch(TicketSaleCreators.setPriceReturn(payload.price))
}
const deselectBusSeatReturn = (payload) => (dispatch) => {
	dispatch({
		payload,
		type: busSeatSelectionConstants.DESELECT_BUS_SEAT_RETURN,
	})
}

const setTotalSeatsGoing = (payload) => (dispatch) => {
	dispatch({
		payload,
		type: busSeatSelectionConstants.SET_TOTAL_SEATS_GOING,
	})
}

const setOrdemViagemIda = (payload) => (dispatch) => {
	dispatch({
		payload,
		type: busSeatSelectionConstants.SET_ORDEM_VIAGEM_IDA,
	})
}

const getOrdemViagemIda = () => ({
	type: busSeatSelectionConstants.GET_ORDEM_VIAGEM_IDA,
})

const setTotalSeatsReturn = (payload) => (dispatch) => {
	dispatch({
		payload,
		type: busSeatSelectionConstants.SET_TOTAL_SEATS_RETURN,
	})
}

const reset = () => ({
	type: busSeatSelectionConstants.RESET,
})

const getNumberOfPassengers = () => ({
	type: busSeatSelectionConstants.GET_NUMBER_OF_PASSENGERS,
})

export const busSeatSelectionActions = {
	reset,
	loadBusSeatsGoing,
	loadBusSeatsReturn,
	loadBusSeatsGoingConexao,
	loadBusSeatsReturnConexao,
	selectBusSeatGoing,
	setTotalSeatsGoing,
	selectBusSeatReturn,
	setTotalSeatsReturn,
	deselectBusSeatGoing,
	deselectBusSeatReturn,
	getNumberOfPassengers,
	setOrdemViagemIda,
	getOrdemViagemIda,
}
